var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSegmentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "forms-svgrepo-com",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4785",
    "data-name": "Path 4785",
    d: "M19,0H5A2.006,2.006,0,0,0,3,2V22a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V2A2.006,2.006,0,0,0,19,0Zm0,21.5a.5.5,0,0,1-.5.5H5.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,5.5,2h13a.5.5,0,0,1,.5.5Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4786",
    "data-name": "Path 4786",
    d: "M10,10H8A1,1,0,0,1,7,9V5A1,1,0,0,1,8,4h2a1,1,0,0,1,1,1V9A1,1,0,0,1,10,10Zm6,6H8a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1v2A1,1,0,0,1,16,16ZM16,6H14a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0,4H14a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0,10H8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentsIcon);
export default __webpack_public_path__ + "static/media/SegmentsIcon.e18856bd3481a82e2223e67a53f89783.svg";
export { ForwardRef as ReactComponent };